module.exports = __webpack_public_path__ + "img/huawuIcon6.eb40b330.png";